import { apiService } from './api';

const BASE_PATH = '/supplier/bookings';

export const bookingService = {
  /**
   * Get all bookings for the authenticated supplier
   * @param {Object} params - Query parameters
   * @param {string} params.status - Filter by booking status
   * @param {number} params.limit - Maximum number of bookings
   * @param {number} params.skip - Number of bookings to skip
   */
  async getBookings(params = {}) {
    const { status, limit = 100, skip = 0 } = params;
    const queryParams = new URLSearchParams();
    if (status) queryParams.append('status', status);
    queryParams.append('limit', limit.toString());
    queryParams.append('skip', skip.toString());
    
    const url = `${BASE_PATH}?${queryParams.toString()}`;
    
    console.log('📞 [bookingService] Fetching bookings from:', url);
    console.log('📞 [bookingService] Params:', { status, limit, skip });
    
    try {
      const response = await apiService.get(url);
      console.log('✅ [bookingService] Bookings fetched successfully:', response);
      return response;
    } catch (error) {
      console.error('❌ [bookingService] Error fetching bookings:', error);
      console.error('❌ [bookingService] Error response:', error?.response?.data);
      console.error('❌ [bookingService] Error status:', error?.response?.status);
      console.error('❌ [bookingService] Error headers:', error?.response?.headers);
      
      // Re-throw with more context
      if (error?.response?.status === 400) {
        const errorMessage = error?.response?.data?.message || error?.response?.data?.error || 'Bad Request - Check authentication and parameters';
        throw new Error(`Failed to fetch bookings: ${errorMessage}`);
      }
      throw error;
    }
  },

  /**
   * Get booking statistics
   */
  async getBookingStats() {
    return apiService.get(`${BASE_PATH}/stats`);
  },

  /**
   * Get a specific booking by ID
   * @param {string} bookingId - Booking ID
   */
  async getBookingById(bookingId) {
    return apiService.get(`${BASE_PATH}/${bookingId}`);
  },

  /**
   * Cancel a booking
   * @param {string} bookingId - Booking ID
   * @param {string} reason - Cancellation reason
   */
  /** BOOK-RULE-002 — body: { reason_code, reason? } or legacy string reason */
  async cancelBooking(bookingId, reasonOrPayload) {
    const body =
      reasonOrPayload && typeof reasonOrPayload === "object"
        ? {
            reason_code: reasonOrPayload.reason_code || reasonOrPayload.reasonCode,
            reason: reasonOrPayload.reason || reasonOrPayload.label,
          }
        : { reason: reasonOrPayload, reason_code: reasonOrPayload };
    return apiService.post(`${BASE_PATH}/${bookingId}/cancel`, body);
  },

  /**
   * Divert booking to another supplier
   * @param {string} bookingId - Booking ID
   * @param {string} recipientEmail - Email of the supplier to divert to
   * @param {string} recipientName - Name of the supplier
   * @param {string} reason - Reason for diversion
   */
  async divertBooking(bookingId, recipientEmail, recipientName, reason) {
    return apiService.post(`${BASE_PATH}/${bookingId}/divert`, {
      recipient_email: recipientEmail,
      recipient_name: recipientName,
      reason: reason
    });
  },

  /**
   * Send email to customer
   * @param {string} bookingId - Booking ID
   * @param {string} subject - Email subject
   * @param {string} message - Email message
   */
  async contactCustomer(bookingId, subject, message) {
    return apiService.post(`${BASE_PATH}/${bookingId}/contact-customer`, {
      subject,
      message
    });
  },
};

export default bookingService;

